import { useIntegrationContext } from '@/contexts/IntegrationContext';
import { useAuth } from '@/contexts/AuthContext';

export interface UseIntegrationFeaturesReturn {
    integrations: ReturnType<typeof useIntegrationContext>['integrations'];
    isLoading: boolean;
    error: string | null;
    /** True when VOIP is enabled and (provider is not arestik/voiceflow_c2c, or current user has extension set). */
    isClickToCallEnabled: boolean;
    isEmailEnabled: boolean;
    isWhatsAppEnabled: boolean;
    isSMSEnabled: boolean;
    isPaymentEnabled: boolean;
    refreshIntegrations: () => Promise<void>;
}

export const useIntegrationFeatures = (): UseIntegrationFeaturesReturn => {
    const { user } = useAuth();
    const { integrations, isLoading, error, refreshIntegrations } = useIntegrationContext();

    const voipActive = integrations?.voip ?? false;
    const voipProvider = integrations?.voip_provider ?? null;
    const userExtension =
        user && 'extension' in user ? (user as { extension?: string }).extension : undefined;
    // arestik and voiceflow_c2c require user extension
    const requiresExtension = voipProvider === 'arestik' || voipProvider === 'voiceflow_c2c';
    const isClickToCallEnabled = voipActive && (!requiresExtension || Boolean(userExtension));

    return {
        integrations,
        isLoading,
        error,
        isClickToCallEnabled,
        isEmailEnabled: integrations?.email ?? false,
        isWhatsAppEnabled: integrations?.whatsapp ?? false,
        isSMSEnabled: integrations?.sms ?? false,
        isPaymentEnabled: integrations?.payment ?? false,
        refreshIntegrations,
    };
};
